<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-calculator"></i>
        <div class="mg-l-20">
          <h4>
            {{ $t("financial.利润报表管理") }}
          </h4>
        </div>
      </div>
      <div class="tx-right">
        <button
          class="btn btn-success"
          type="button"
          @click="createProfit"
          v-if="isSysRights('Profit.create')"
        >
          {{ $t("financial.生成利润报表") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyCode"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('code')"
        >
          {{ $t("financial.报表编号：") }}
          <span class="mg-r-10">{{ keyCode }}</span>
          <i class="fa fa-close"></i>
        </a>

        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('name')"
        >
          {{ $t("financial.报表名：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>

        <a
          v-show="keyDateFrom"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('dateFrom')"
        >
          {{ $t("financial.起始日期：") }}
          <span class="mg-r-10">{{ keyDateFrom }}</span>
          <i class="fa fa-close"></i>
        </a>

        <a
          v-show="keyDateTo"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('dateTo')"
        >
          {{ $t("financial.截止日期：") }}
          <span class="mg-r-10">{{ keyDateTo }}</span>
          <i class="fa fa-close"></i>
        </a>

        <a
          v-show="keyStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('status')"
        >
          {{ $t("financial.状态：") }}
          <span class="mg-r-10">{{ $t($dict.profitStatus[keyStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keyCode", "keyDateFrom", "keyDateTo", "keyStatus"],
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    createProfit() {
      this.$emit("createProfit");
    },
  },
};
</script>